import { AppBar, Toolbar, Typography } from '@mui/material'
import { navbarStyles } from './NavbarStyles'
import NavbarNavigation from './NavbarNavigation'
import { NAVBAR } from '../../content/Content'
import { NavbarHeaderProps } from '../../interfaces/NavbarHeaderProps'

const NavbarHeader: React.FC<NavbarHeaderProps> = ({
   navigateTo,
   anchorEl,
   open,
   handleClick,
   handleClose,
}) => (
   <AppBar sx={navbarStyles.appBar}>
      <Toolbar sx={navbarStyles.toolbar}>
         <Typography variant="h6" sx={navbarStyles.title}>
            {NAVBAR.title}
         </Typography>
         <NavbarNavigation
            navigateTo={navigateTo}
            anchorEl={anchorEl}
            open={open}
            handleClick={handleClick}
            handleClose={handleClose}
         />
      </Toolbar>
   </AppBar>
)

export default NavbarHeader
